var _path, _g, _path2, _g2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPolygon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_331_25201)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_331_25201",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_331_25201",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 23,
    height: 23
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7601 21.7602H-0.760254V-0.760193H21.7601V21.7602Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_331_25201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7857 10.5C20.7857 16.1826 16.1825 20.7858 10.4999 20.7858C4.81731 20.7858 0.214111 16.1826 0.214111 10.5C0.214111 4.81743 4.81731 0.214233 10.4999 0.214233C16.1825 0.214233 20.7857 4.81743 20.7857 10.5Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_331_25201)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_331_25201",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7942 0.205811H0.209961V20.79H20.7942V0.205811Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_331_25201)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.7245,
    height: 20.6438,
    transform: "matrix(1 0 0 -1 0.179688 20.8202)",
    fill: "white"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4735 12.7176L16.3841 11.0376C16.5395 10.9494 16.6319 10.7814 16.6319 10.605V7.24503C16.6319 7.06863 16.5353 6.90063 16.3841 6.81243L13.4735 5.13243C13.3181 5.04423 13.1291 5.04423 12.9737 5.13243L10.0631 6.81243C9.90767 6.90063 9.81527 7.06863 9.81527 7.24503V13.251L7.77407 14.427L5.73287 13.251V10.8948L7.77407 9.71883L9.12227 10.4958V8.91663L8.02607 8.28243C7.95047 8.24043 7.86227 8.21523 7.77827 8.21523C7.69007 8.21523 7.60607 8.23623 7.53047 8.28243L4.61987 9.96243C4.46447 10.0506 4.37207 10.2186 4.37207 10.395V13.755C4.37207 13.9314 4.46867 14.0994 4.61987 14.1876L7.53047 15.8676C7.68587 15.9558 7.87487 15.9558 8.03027 15.8676L10.9409 14.1876C11.0963 14.0994 11.1887 13.9314 11.1887 13.755V7.74903L11.2265 7.72803L13.2299 6.57303L15.2711 7.74903V10.1052L13.2299 11.2812L11.8859 10.5042V12.0834L12.9821 12.7134C13.1291 12.81 13.3223 12.81 13.4735 12.7176Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_331_25201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPolygon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/polygon.92edfca443c51627adfae88c1cfbf285.svg";